import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'parseNumber',
    standalone: false
})
export class ParseNumberPipe implements PipeTransform {
  transform(value: string, format): number {
    const numberValue = parseFloat(value);
    return Number.isNaN(numberValue) ? 0 : numberValue;
  }
}
